module.exports = __webpack_public_path__ + "img/sii-icon-active.7a617edf.svg";